import { Component, inject } from '@angular/core';
import { MatDialogActions, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-unsaved-changes-dialog',
  imports: [MatButton, MatDialogActions, MatDialogContent, MatIcon],
  templateUrl: './unsaved-changes-dialog.html',
})
export class UnsavedChangesDialog {
  readonly dialogRef = inject(MatDialogRef<UnsavedChangesDialog>);
}
